export default class DefaultGrouping {
  constructor() {
    this.name = '';
    this.displayName = '';
    this.ungroupedName = '';
    this.selectorReverseSorted = false;
    this.groupByPulldown = true;
    this.secondarySortable = true;
    this.reverseSortable = false;
    this.groupingReverseSorted = null;
    this.sortDirectionText = {
      true: {
        text: '',
        icon: ''
      },
      false: {
        text: '',
        icon: ''
      }
    };
    // sort branches based on their id (constructed in buildTree)
    this.sortingKey = 'displayName';
  }

  setColumns(cols) {
    return cols.map(function (col, i) {
      return {
        key: col,
        visible: i < 5
      };
    });
  }

  getDocDisplayStyles() {
    return {
      'border-style': 'solid',
      'border-width': '1px',
      'width': '11%',
      'padding': '3px'
    };
  }

  getDisplayText(value) {
    return value;
  }

  getDisplayName(branch) {
    // called from a Branch
    return branch.displayName || this.ungroupedName;
  }

  getOutlineText(branch) {
    return this.getDisplayName(branch);
  }

  getFactItems(fact) {
    return [];
  }
  getItemsByFact(fact) {
    var items = [];
    items.push(fact[this.name]);
    return items;
  }
}



// WEBPACK FOOTER //
// ./project/groupings/default.js